import axios from "axios";

export default function ScheduleitemsDeleteService(scheduleItemId) {
  return axios({
    method: 'delete',
    url: process.env.REACT_APP_API_HOST + "/schedule_item/" + scheduleItemId,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
